import request from './base/api';

export function fetchProductPlans(cb, errCb) {
  return request({
    url: 'product-plan',
    method: 'get',
    cb,
    errCb
  });
}

export default {
  fetchProductPlans
};
